<template>
  <Content class="goodsBox">
    <Form id="searchForm" :model="formItem" :label-width="90" inline>
      <FormItem label="内容/用户">
        <Input v-model="formItem.key" placeholder="内容、昵称、手机号" clearable />
      </FormItem>
      <FormItem label="状态">
        <Select v-model="formItem.status" placeholder="全部" clearable style="width: 100px">
          <Option value="">全部</Option>
          <Option value="pending">待处理</Option>
          <Option value="processed">已处理</Option>
        </Select>
      </FormItem>
      <FormItem :label-width="20">
        <Button type="primary" @click="search">查询</Button>
        <Button style="margin-left: 8px" @click="clear">重置</Button>
      </FormItem>
    </Form>
    <Table
      :columns="columns"
      :data="tableData"
      :height="tablesHeight"
      border
    ></Table>
    <Page
      class="table_page_css"
      v-show="total"
      :total="total"
      :current="searchInfo.pageNo"
      :page-size="searchInfo.pageSize"
      :page-size-opts="pageSizeOpts"
      @on-change="pageNoChange"
      @on-page-size-change="pageSizeChange"
      show-sizer
      show-elevator
      show-total
    />
    <Modal v-model="replyModal.visible" title="回复用户" width="520" @on-ok="submitReply" @on-cancel="replyModal.visible = false">
      <Input v-model="replyModal.reply" type="textarea" :rows="4" placeholder="请输入回复内容，用户可在「我的投诉建议」中查看" />
    </Modal>
    <Modal v-model="previewVisible" title="图片预览" width="600" footer-hide :mask-closable="true" @on-cancel="previewVisible = false">
      <div class="preview-wrap">
        <img v-if="previewList.length" :src="previewList[previewIndex]" class="preview-img" @click.stop />
        <div v-if="previewList.length > 1" class="preview-nav">
          <Button size="small" :disabled="previewIndex <= 0" @click="previewIndex = Math.max(0, previewIndex - 1)">上一张</Button>
          <span class="preview-num">{{ previewIndex + 1 }} / {{ previewList.length }}</span>
          <Button size="small" :disabled="previewIndex >= previewList.length - 1" @click="previewIndex = Math.min(previewList.length - 1, previewIndex + 1)">下一张</Button>
        </div>
      </div>
    </Modal>
    <Modal v-model="detailModal.visible" title="详情" width="560" footer-hide :mask-closable="true" @on-cancel="detailModal.visible = false">
      <div v-if="detailModal.row" class="detail-wrap">
        <div class="detail-row"><span class="detail-label">昵称：</span>{{ detailModal.row.nickname || '-' }}</div>
        <div class="detail-row"><span class="detail-label">手机号：</span>{{ detailModal.row.phone || '-' }}</div>
        <div class="detail-row"><span class="detail-label">提交时间：</span>{{ formatDetailTime(detailModal.row.createdAt) }}</div>
        <div class="detail-row"><span class="detail-label">状态：</span>{{ detailModal.row.status === 'processed' ? '已处理' : '待处理' }}</div>
        <div class="detail-row"><span class="detail-label">内容：</span><span class="detail-content">{{ detailModal.row.value || '-' }}</span></div>
        <div class="detail-row"><span class="detail-label">回复：</span><span class="detail-content">{{ detailModal.row.reply || '未回复' }}</span></div>
      </div>
    </Modal>
  </Content>
</template>
<script>
import { ComplaintList, ComplaintStatus } from '@/api/complaint'
export default {
  name: 'Complaint',
  data() {
    return {
      columns: [
        { type: 'index', width: 56, align: 'center' },
        { title: '昵称', key: 'nickname', width: 100, ellipsis: true },
        { title: '手机号', key: 'phone', width: 135, ellipsis: true },
        { title: '内容', key: 'value', minWidth: 220, ellipsis: true },
        {
          title: '状态',
          key: 'status',
          width: 96,
          align: 'center',
          render: (h, { row }) => {
            const isPending = row.status !== 'processed'
            return h('Tag', { props: { color: isPending ? 'warning' : 'success' } }, isPending ? '待处理' : '已处理')
          },
        },
        {
          title: '提交时间',
          key: 'createdAt',
          width: 165,
          render: (h, { row }) => h('span', row.createdAt ? new Date(row.createdAt).toLocaleString() : '-'),
        },
        {
          title: '回复',
          key: 'reply',
          minWidth: 260,
          ellipsis: true,
          render: (h, { row }) => {
            const text = row.reply ? (row.reply.length > 35 ? row.reply.slice(0, 35) + '…' : row.reply) : '未回复'
            return h('span', {
              style: { color: row.reply ? '#1890ff' : '#999', cursor: 'pointer', textDecoration: row.reply ? 'underline' : 'none' },
              on: { click: () => this.showDetail(row) },
            }, text)
          },
        },
        {
          title: '图片',
          key: 'imgmes',
          width: 100,
          align: 'center',
          render: (h, params) => {
            const row = params.row
            const list = Array.isArray(row.imgList) && row.imgList.length ? row.imgList : (row.imgmes ? [row.imgmes] : [])
            if (!list.length) return h('span', { style: { color: '#999' } }, '无')
            const base = process.env.VUE_APP_BASEURL || ''
            return h(
              'div',
              { style: { display: 'flex', flexWrap: 'wrap', gap: '4px', justifyContent: 'center', alignItems: 'center' } },
              list.slice(0, 4).map((url, i) =>
                h('img', {
                  key: i,
                  attrs: { src: base + url },
                  style: { width: '32px', height: '32px', objectFit: 'cover', cursor: 'pointer', borderRadius: '4px' },
                  on: { click: () => this.showPreview(row, i) },
                })
              ).concat(list.length > 4 ? [h('span', { style: { fontSize: '12px', color: '#999', marginLeft: '2px' } }, `+${list.length - 4}`)] : [])
            )
          },
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const row = params.row
            const isPending = row.status !== 'processed'
            return h('div', [
              isPending
                ? h('Button', {
                    props: { type: 'primary', size: 'small' },
                    style: { marginRight: '8px' },
                    on: { click: () => this.openReply(row) },
                  }, '回复')
                : null,
              isPending
                ? h('Button', {
                    props: { size: 'small' },
                    on: { click: () => this.setStatus(row._id, 'processed') },
                  }, '标记已处理')
                : null,
            ])
          },
        },
      ],
      tableData: [],
      total: 0,
      searchInfo: { pageNo: 1, pageSize: 10 },
      pageSizeOpts: [5, 10, 20, 50],
      formItem: { key: '', status: '' },
      tablesHeight: 0,
      replyModal: { visible: false, _id: null, reply: '' },
      previewVisible: false,
      previewList: [],
      previewIndex: 0,
      detailModal: { visible: false, row: null },
    }
  },
  methods: {
    showDetail(row) {
      this.detailModal.row = row
      this.detailModal.visible = true
    },
    formatDetailTime(t) {
      if (!t) return '-'
      try {
        return new Date(t).toLocaleString()
      } catch (e) {
        return '-'
      }
    },
    showPreview(row, index) {
      const list = Array.isArray(row.imgList) && row.imgList.length ? row.imgList : (row.imgmes ? [row.imgmes] : [])
      if (!list.length) return
      const base = process.env.VUE_APP_BASEURL || ''
      this.previewList = list.map((url) => base + url)
      this.previewIndex = index
      this.previewVisible = true
    },
    // 设置表格高度，使其适应视口大小
    setTablesHeight() {
      let aH = 0 // 初始化表格高度变量
      let oA = document.getElementById('app') // 获取包含整个应用的DOM元素
      let oH = oA.clientHeight || oA.offsetHeight // 获取应用的高度
      let sA = document.getElementById('searchForm') // 获取搜索表单的DOM元素
      let sH = sA.clientHeight || sA.offsetHeight // 获取搜索表单的高度
      aH = oH - sH - 265 // 计算表格的高度（应用高度 - 搜索表单高度 - 预留的固定高度）
      this.tablesHeight = aH // 将计算得到的表格高度赋值给组件的数据属性
    },

    // 获取客户列表数据的函数
    getList() {
      const { key, status } = this.formItem
      const params = { ...this.searchInfo, key: key || undefined, status: status || undefined }
      ComplaintList(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.tableData = res.data.data || []
            this.total = res.data.total || 0
          } else {
            this.$Message.error(res.data.msg || '获取列表失败')
          }
        })
        .catch((err) => this.$Message.error(err && err.message ? err.message : '获取列表失败'))
    },

    // 执行搜索操作的函数
    search() {
      this.searchInfo.pageNo = 1
      this.searchInfo.key = this.formItem.key
      this.searchInfo.status = this.formItem.status
      this.getList()
    },

    // 清除搜索条件并重新获取列表数据的函数
    clear() {
      this.formItem = { key: '', status: '' }
      this.searchInfo = { pageNo: 1, pageSize: this.searchInfo.pageSize, key: undefined, status: undefined }
      this.getList()
    },

    // 删除区域的函数
    openReply(row) {
      this.replyModal._id = row._id
      this.replyModal.reply = row.reply || ''
      this.replyModal.visible = true
    },
    submitReply() {
      if (!this.replyModal._id) return
      ComplaintStatus({ _id: this.replyModal._id, status: 'processed', reply: this.replyModal.reply })
        .then((res) => {
          if (res.data.code === 200) {
            this.$Message.success('回复成功')
            this.replyModal.visible = false
            this.replyModal._id = null
            this.replyModal.reply = ''
            this.getList()
          } else this.$Message.error(res.data.msg || '操作失败')
        })
        .catch((err) => this.$Message.error(err && err.message ? err.message : '操作失败'))
    },
    setStatus(_id, status) {
      ComplaintStatus({ _id, status })
        .then((res) => {
          if (res.data.code === 200) {
            this.$Message.success('已标记为已处理')
            this.getList()
          } else this.$Message.error(res.data.msg || '操作失败')
        })
        .catch((err) => this.$Message.error(err && err.message ? err.message : '操作失败'))
    },

    // 当页码发生变化时的处理函数
    pageNoChange(current) {
      this.searchInfo.pageNo = current // 更新当前页码
      this.getList() // 重新获取列表数据
    },

    // 当页大小发生变化时的处理函数
    pageSizeChange(val) {
      this.searchInfo.pageNo = 1 // 重置页码为1
      this.searchInfo.pageSize = val // 更新页大小
      this.getList() // 重新获取列表数据
    },
  },
  mounted() {
    this.getList()
    setTimeout(() => {
      this.setTablesHeight()
    }, 50)
    window.onresize = () => {
      this.setTablesHeight()
    }
  },
}
</script>
  <style lang="less" scoped>
.goodsBox {
  .ivu-form-inline .ivu-form-item {
    width: 267px;
  }
  .ivu-table-wrapper {
    width: 100%;
  }
  .ivu-table {
    width: 100% !important;
  }
}
.preview-wrap {
  text-align: center;
  padding: 10px 0;
  .preview-img {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }
  .preview-nav {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    .preview-num {
      color: #666;
      font-size: 14px;
    }
  }
}
.detail-wrap {
  padding: 8px 0;
  .detail-row {
    margin-bottom: 12px;
    line-height: 1.6;
    .detail-label {
      color: #666;
      margin-right: 8px;
    }
    .detail-content {
      word-break: break-all;
      white-space: pre-wrap;
    }
  }
}
</style>
  